if (!customElements.get('cooking-videos')) {
  class CookingVideos extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('[data-videos-list]');
      this.controls = this.querySelector('.cooking-videos__controls');
      this.prevButton = this.querySelector('[data-videos-prev]');
      this.nextButton = this.querySelector('[data-videos-next]');
      this.counterStart = this.querySelector('[data-counter-start]');
      this.counterEnd = this.querySelector('[data-counter-end]');
      this.updateControls = this.updateControls.bind(this);
    }

    connectedCallback() {
      if (!this.list) return;

      this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
      this.nextButton.addEventListener('click', () => this.scrollByCard(1));
      this.list.addEventListener('scroll', this.updateControls, { passive: true });
      this.list.addEventListener('click', (event) => {
        const playButton = event.target.closest('[data-video-play]');
        if (playButton) this.playVideo(playButton);
      });
      // One clip at a time, including when a paused clip is restarted from its own controls.
      this.list.addEventListener(
        'play',
        (event) => {
          this.list.querySelectorAll('video').forEach((video) => {
            if (video !== event.target) video.pause();
          });
        },
        true
      );

      this.resizeObserver = new ResizeObserver(this.updateControls);
      this.resizeObserver.observe(this.list);
      this.updateControls();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    // The video is only created on tap, so the homepage never downloads clips nobody watches.
    playVideo(playButton) {
      const media = playButton.closest('.cooking-videos__media');
      const template = media.querySelector('[data-video-template]');
      if (!template) return;

      const video = template.content.querySelector('video').cloneNode(true);
      media.appendChild(video);
      playButton.remove();
      const playing = video.play();
      if (playing) playing.catch(() => {});
    }

    getCards() {
      return Array.from(this.list.querySelectorAll('.cooking-videos__card'));
    }

    // Controls show only when there is something to scroll to.
    updateControls() {
      const cards = this.getCards();
      const maxScroll = this.list.scrollWidth - this.list.clientWidth;
      this.controls.hidden = maxScroll <= 4 || cards.length === 0;
      this.prevButton.disabled = this.list.scrollLeft <= 2;
      this.nextButton.disabled = this.list.scrollLeft >= maxScroll - 2;

      const listLeft = this.list.getBoundingClientRect().left;
      const listRight = listLeft + this.list.clientWidth;
      const fullyVisible = cards
        .map((card, index) => ({ rect: card.getBoundingClientRect(), index }))
        .filter(({ rect }) => rect.left >= listLeft - 2 && rect.right <= listRight + 2);
      if (!fullyVisible.length) return;
      this.counterStart.textContent = fullyVisible[0].index + 1;
      this.counterEnd.textContent = fullyVisible[fullyVisible.length - 1].index + 1;
    }

    scrollByCard(direction) {
      const card = this.list.querySelector('.cooking-videos__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
      this.list.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
    }
  }

  customElements.define('cooking-videos', CookingVideos);
}
